import { css } from '@emotion/react';
import { HEIGHT_MAX, WIDTH_MAX } from '@pages/Main/MainView/constants';

export const rootContainer = css({
  width: WIDTH_MAX,
  height: HEIGHT_MAX
});

export const backButtonContainer = css({
  padding: '64px'
});

export const image = css({
  width: WIDTH_MAX,
  height: HEIGHT_MAX
});
